import CardCheckList from "../../../../components/ui/cards/card-check-list/card-check-list";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";

import { PATH, SECTIONS_ID } from "../../../../constants/navigation";
import { Link } from "react-router-dom";

import "./our-services.scss";
import { Fade, Slide } from "react-awesome-reveal";

type OurServicesPropsT = {
  title: string;
  text: string;
};

const OurServices = ({ text, title }: OurServicesPropsT) => {
  const device = useBreakpoint();

  const isMobile = device === "mobile" || device === "tablet";
  return (
    <section className="our-services" id={SECTIONS_ID.home.services}>
      <Fade direction="up" triggerOnce duration={700}>
        <div className="our-services__description">
          <h2 className="our-services__title">{title}</h2>
          <p className="our-services__text">{text}</p>
        </div>
      </Fade>

      <div className="our-services__cards">
        <Slide direction="up" triggerOnce duration={800} cascade damping={0.2}>
          <Link to={PATH.poles}>
            <div className="our-services__card">
              <CardCheckList
                title="Pali Rotoinfissi"
                text="Pali in c.a. infissi a rotazione con punta a perdere, ideali per fondazioni senza scavi né significative vibrazioni."
                icon="hole"
                type="primary"
                elements={[
                  "Senza vibrazioni significative",
                  "Adatti a zone urbane",
                  "Tecnologia avanzata",
                  "Fondazioni profonde",
                  "Alta resistenza strutturale",
                ]}
                maxWidth={!isMobile ? "25rem" : ""}
              />
            </div>
          </Link>

          <Link to={PATH.consultancy}>
            <div className="our-services__card">
              <CardCheckList
                title="Consulenza e Coordinamento"
                text="Guidiamo il cliente verso studi tecnici e professionisti di fiducia, garantendo coerenza e continuità fino alla fase operativa."
                icon="clipboard"
                type="secondary"
                elements={[
                  "Indirizzamento tecnico",
                  "Coordinamento tecnico",
                  "Supporto operativo",
                  "Verifica in cantiere",
                  "Esecuzione su misura",
                ]}
                maxWidth={!isMobile ? "25rem" : ""}
              />
            </div>
          </Link>
        </Slide>
      </div>
    </section>
  );
};

export default OurServices;
